var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.341,
    height: 40.174,
    viewBox: "0 0 35.341 40.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19099.482 13887.186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.148,4.772H9.543V-.807A1.2,1.2,0,0,0,8.35-2H5.965A1.2,1.2,0,0,0,4.772-.807V4.772H-.807A1.2,1.2,0,0,0-2,5.965V8.35A1.2,1.2,0,0,0-.807,9.543H4.772V36.981a1.2,1.2,0,0,0,1.193,1.193H8.35a1.2,1.2,0,0,0,1.193-1.193V9.543h22.6A1.2,1.2,0,0,0,33.341,8.35V5.965A1.2,1.2,0,0,0,32.148,4.772Z",
    transform: "translate(-19097.482 -13885.186)",
    fill: "#fd6c50"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19085.119 -13872.912)",
    fill: "none",
    stroke: "#fd6c50",
    strokeWidth: 4.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.978,
    height: 25.901,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.35,
    y: 2.35,
    width: 16.278,
    height: 21.201,
    rx: 0.85,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoLogo);
export default __webpack_public_path__ + "static/media/lo_logo.4851aa555883d82e7534dd5e5e3ad42c.svg";
export { ForwardRef as ReactComponent };